const updateCurrent = function (current) {
  const indicators = document.querySelectorAll('.indicator');
  indicators.forEach((indicator, i) => {
    if (i == current) indicator.classList.add('active');
    else indicator.classList.remove('active');
  });
};

export const productSliderFn = function () {
  const slides = document.querySelectorAll('.slide');
  const nextBtn = document.querySelector('.next');
  const prevBtn = document.querySelector('.prev');
  const slideWrapper = document.querySelector('.slide-wrapper');
  const indicators = document.querySelectorAll('.indicator');

  indicators[0].classList.add('active');
  let currentIndex = 0;
  const totalSlides = slides.length;

  function updateSlider() {
    slideWrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
    updateCurrent(currentIndex);
  }

  let interval = setInterval(() => {
    currentIndex = (currentIndex + 1) % totalSlides;
    updateSlider();
  }, 3000);

  prevBtn.addEventListener('click', (e) => {
    currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
    updateSlider();
    clearInterval(interval);
    interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % totalSlides;
      updateSlider();
    }, 3000);
  });
  nextBtn.addEventListener('click', (e) => {
    currentIndex = (currentIndex + 1) % totalSlides;
    updateSlider();
    clearInterval(interval);
    interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % totalSlides;
      updateSlider();
    }, 3000);
  });
  indicators.forEach((indicator, i) => {
    indicator.addEventListener('click', (e) => {
      currentIndex = i;
      updateSlider();
      clearInterval(interval);
      interval = setInterval(() => {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlider();
      }, 3000);
    });
  });

  // * SWIPE - MOBILE
  let startX = 0;
  let startY = 0;

  slideWrapper.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  });
  slideWrapper.addEventListener('touchend', (e) => {
    const endX = e.changedTouches[0].clientX;
    const endY = e.changedTouches[0].clientY;

    const diffX = endX - startX;
    const diffY = endY - startY;

    //  ONLY HORIZONTAL
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 20) {
      // RIGHT SWIPE
      if (diffX > 0) {
        currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        updateSlider();

        clearInterval(interval);

        // SETTING NEW INTERVAL
        interval = setInterval(() => {
          currentIndex = (currentIndex + 1) % totalSlides;
          updateSlider();
        }, 3000);
      } else {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlider();
        clearInterval(interval);

        // SETTING NEW INTERVAL
        interval = setInterval(() => {
          currentIndex = (currentIndex + 1) % totalSlides;
          updateSlider();
        }, 3000);
      }
    }
  });
};
